import { render, staticRenderFns } from "./check-note.vue?vue&type=template&id=11208547&scoped=true"
import script from "./check-note.vue?vue&type=script&lang=ts"
export * from "./check-note.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11208547",
  null
  
)

export default component.exports